import React from 'react';
import { ActionIcon, Popover, Stack, UnstyledButton, Text, Group } from '@mantine/core';
import { IconQuestionMark, IconMail, IconHelp, IconBulb, IconBook } from '@tabler/icons-react';
import { Link } from '@inertiajs/react';

const FloatingHelpMenu = () => {
  console.log('🎯 FloatingHelpMenu is rendering!');

  const menuItems = [
    {
      icon: IconMail,
      label: 'Email support',
      href: 'mailto:hello@wherecanwedance.com',
      external: true,
    },
    {
      icon: IconHelp,
      label: 'FAQ',
      href: '/faq',
      external: false,
    },
    {
      icon: IconBulb,
      label: 'Feature requests',
      href: 'http://www.wherecanwedance.com/feedback',
      external: true,
    },
    {
      icon: IconBook,
      label: 'Help center',
      href: 'https://help.wherecanwedance.com',
      external: true,
    },
  ];

  const MenuItem = ({ item }) => {
    const content = (
      <Group gap="sm" p="sm" style={{ cursor: 'pointer' }}>
        <item.icon size={20} color="#666" />
        <Text size="sm" c="dimmed">
          {item.label}
        </Text>
      </Group>
    );

    if (item.external) {
      return (
        <UnstyledButton
          component="a"
          href={item.href}
          target={item.href.startsWith('http') ? '_blank' : undefined}
          rel={item.href.startsWith('http') ? 'noopener noreferrer' : undefined}
          style={{
            display: 'block',
            width: '100%',
            borderRadius: '4px',
            '&:hover': {
              backgroundColor: '#f8f9fa',
            },
          }}
        >
          {content}
        </UnstyledButton>
      );
    }

    return (
      <UnstyledButton
        component={Link}
        href={item.href}
        style={{
          display: 'block',
          width: '100%',
          borderRadius: '4px',
          '&:hover': {
            backgroundColor: '#f2f2f2',
          },
        }}
      >
        {content}
      </UnstyledButton>
    );
  };

  return (
    <div
      style={{
        position: 'fixed',
        bottom: '24px',
        right: '24px',
        zIndex: 1000,
      }}
    >
      <Popover width={200} position="top-end" withArrow shadow="md">
        <Popover.Target>
          <ActionIcon
            size="xl"
            radius="xl"
            variant="filled"
            color="white"
            style={{
              boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
            }}
          >
            <IconQuestionMark size={24} color="#EA580C" stroke={2.5} />
          </ActionIcon>
        </Popover.Target>

        <Popover.Dropdown p={0}>
          <Stack gap={0}>
            {menuItems.map((item, index) => (
              <MenuItem key={index} item={item} />
            ))}
          </Stack>
        </Popover.Dropdown>
      </Popover>
    </div>
  );
};

export default FloatingHelpMenu;
